<div id="accordionSubjThemes" class="max-width" *ngIf="syllabusinfo">
    <div class="text-center alert alert-info" *ngIf="renderMathNow" [appMath]="' Click on a Sub Topic To Revise'"></div>
      <div *ngFor="let topic of syllabusinfo.topics; index as myCount;" class="card" >

        <div class="card-header" id="headingTheme{{topic.id}}">
          <h5 class="mb-0">
          <span *ngIf="(subscription.is_premium || topic.is_open)">
           <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
                <i class="fa fa-caret-right"> </i> {{topic.name}}
            </a>
          </span>
          <span *ngIf="!(subscription.is_premium || topic.is_open)">
            <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
            <i class="fa fa-caret-right text-primary"></i> <span> {{topic.name}} </span>
            </a>
          </span>
          </h5>
        </div>

        <div id="collapseTheme{{topic.id}}" class="collapse {{myCount==0?'show':''}}" aria-labelledby="headingTheme{{topic.id}}" data-parent="#accordionSubjThemes">
          <div class="card-body">

            <ul style="list-style: none;">
              <li *ngFor="let subtopic of topic.subtopics;">
                      <span *ngIf ="(subtopic.is_open || subscription.is_premium)">
                        <a [routerLink]="['/student/lesson/subtopic',subtopic.id]" *ngIf="subtopic.hasTemplates" >
                            <i class="fa fa-caret-right text-primary"></i> {{subtopic.name}}
                        </a>
                       <span *ngIf="!subtopic.hasTemplates"> <i class="fa fa-caret-right text-secondary"> </i> {{subtopic.name}}</span>
                      </span>
                      <span *ngIf ="!(subtopic.is_open ||subscription.is_premium)" >
                        <i class="fa fa-caret-right"> </i>  (premium) {{subtopic.name}}
                      </span>

              </li>

          </ul>

          </div>
        </div>

    </div>
    </div>
    <app-spinner *ngIf="!syllabusinfo"></app-spinner>

